import React, { useState } from 'react';
import { X, Maximize2, Minimize2, MessageSquare } from 'lucide-react';
import { MessagesPage } from './MessagesPage';
import { cn } from '@/lib/utils';

interface MessagesPopupProps {
  onClose: () => void;
  initialConversationId?: string | null;
  initialUserId?: string | null;
}

export function MessagesPopup({ onClose, initialConversationId, initialUserId }: MessagesPopupProps) {
  const [isMinimized, setIsMinimized] = useState(false);

  return (
    <div 
      className={cn(
        "fixed bottom-4 right-4 z-50 flex flex-col bg-white dark:bg-dark-paper rounded-xl shadow-xl transition-all duration-300",
        isMinimized ? "w-[300px] h-[60px]" : "w-[380px] h-[600px]"
      )}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b dark:border-dark-border bg-white dark:bg-dark-paper">
        <div className="flex items-center gap-2">
          <MessageSquare className="w-5 h-5 text-royal-purple" />
          <h2 className="font-semibold text-gray-900 dark:text-gray-100">Messages</h2>
        </div>
        <div className="flex items-center gap-1">
          <button
            onClick={() => setIsMinimized(!isMinimized)}
            className="p-2 hover:bg-gray-100 dark:hover:bg-dark-elevated rounded-lg transition-colors text-gray-600 dark:text-gray-400"
          >
            {isMinimized ? (
              <Maximize2 className="w-4 h-4" />
            ) : (
              <Minimize2 className="w-4 h-4" />
            )}
          </button>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 dark:hover:bg-dark-elevated rounded-lg transition-colors text-gray-600 dark:text-gray-400"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Content */}
      {!isMinimized && (
        <div className="flex-1 overflow-hidden">
          <MessagesPage 
            initialConversationId={initialConversationId}
            initialUserId={initialUserId}
          />
        </div>
      )}
    </div>
  );
}